// Temporary public release: keep unfinished features preserved for later.
export const PUBLIC_LAUNCH = true;
export const FACEBOOK_COMMUNITY_URL = "https://www.facebook.com/share/g/1LvwmynkeJ/?mibextid=wwXIfr";
